/**
 * NavCutoverSnackbar — spec-48 W5 (DEC-48-8)
 *
 * One-time snackbar shown on first load after the spec-48 deploy.
 * Suppressed permanently once dismissed via localStorage flag.
 * Does NOT show if the flag is already set (returning users).
 */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const FLAG_KEY = 'jylaw_nav_cutover_v48_dismissed';

const NavCutoverSnackbar: React.FC = () => {
  const { i18n } = useTranslation('common');
  const rtl = i18n.language === 'ar';
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(FLAG_KEY)) {
        setOpen(true);
      }
    } catch { /* localStorage unavailable — skip */ }
  }, []);

  const handleClose = () => {
    setOpen(false);
    try { localStorage.setItem(FLAG_KEY, '1'); } catch { /* ignore */ }
  };

  const message = rtl
    ? 'تم تقسيم تبويب "التأسيس" إلى: تأسيس — التسجيل، ما بعد التأسيس، والمعاملات لتسهيل التصفح.'
    : 'Setup tab is now split into Setup \u2014 Registration, Post-Incorporation, and Transactions for clearer navigation.';

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: rtl ? 'left' : 'right' }}
      autoHideDuration={12000}
    >
      <Alert
        onClose={handleClose}
        severity="info"
        variant="filled"
        sx={{ maxWidth: 480, fontSize: '0.875rem' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NavCutoverSnackbar;
